import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to top on every route/pathname change.
// Skips hash-only navigation (in-page anchors keep native behaviour).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
}
